<div class="row col">
    <div class="mt-3">
        <a class="btn btn-link p-0" (click)="passwordChange()">Cambio de contraseña</a>
    </div>

</div>
<div class="row mt-2">
    <div class="card">
        <div class="card-header">Datos Personales</div>
        @if (profile.hasValue())
        {
        <div class="card-body">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="name" class="form-label">Id</label>
                    <input type="text" id="name" class="form-control" [value]="profile.value().id" readonly>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="name" class="form-label">Nombre</label>
                    <input type="text" id="name" class="form-control" [value]="profile.value().name" readonly>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="email" class="form-label">Email</label>
                    <input type="email" id="email" class="form-control" [value]="profile.value().email" readonly>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="phoneNumber" class="form-label">Teléfono</label>
                    <input type="text" id="phoneNumber" class="readonly form-control" [value]="profile.value().phoneNumber"
                        readonly>
                </div>
            </div>


        </div>
        }
    </div>
</div>
<div class="row">
    <div class="col">
        <div class="card mt-4">
            <div class="card-header">Credenciales (Passkeys)</div>
            <div class="card-body">
                <div class="table-responsive">
                    <table class="table table-striped table-hover align-middle mb-0">
                        <thead class="table-light">
                            <tr>
                                <th scope="col">Navegador</th>
                                <th scope="col">Creado</th>
                                <th scope="col" class="text-end">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (passKey of passKeys.value() ?? []; track passKey.credentiaId) {
                            <tr>
                                <td>{{ passKey.name }}</td>
                                <td>{{ passKey.createdAt ? (passKey.createdAt | date:'dd/MM/yyyy HH:mm') : '-' }}</td>
                                <td class="text-end">
                                    <a h class="btn btn-link link-danger text-decoration-none"
                                        (click)="deletePassKey(passKey.credentiaId, $event)">Eliminar</a>
                                </td>
                            </tr>
                            } @empty {
                            <tr>
                                <td colspan="3" class="text-center text-muted py-3">No hay pass keys registradas.</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </div>
</div>